import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  useState,
} from "react"
import { LinkCollection } from "../../carlsberg-headless/types/LinkCollection"

export interface NavigationProviderContext {
  isOpen: boolean
  setIsOpen?: Dispatch<boolean>
  linkCollection?: LinkCollection
  cultureSelector?: LinkCollection
}

const NavigationContext = createContext<NavigationProviderContext>({
  isOpen: false,
  setIsOpen: undefined,
  linkCollection: undefined,
  cultureSelector: undefined,
})

const NavigationProvider: React.FC<
  PropsWithChildren<{
    linkCollection: LinkCollection
    cultureSelector: LinkCollection
  }>
> = ({ linkCollection, cultureSelector, children }) => {
    
  const [isOpen, setIsOpen] = useState(false)

  return (
    <NavigationContext.Provider
      value={{
        isOpen,
        setIsOpen,
        linkCollection,
        cultureSelector,
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}

export { NavigationProvider, NavigationContext }
